class importedProjectModel {
  constructor({ design, artist, brand, image, product_id, variant_id }) {
    this.design = design;
    this.artist = artist;
    this.brand = brand;
    this.image = image;
    this.product_id = product_id;
    this.variant_id = variant_id;
  }
}

class importDataModel {
  constructor({ data = [], status = 1, message = "" }) {
    this.data = data.map((project) => new importedProjectModel(project));
    this.status = status;
    this.message = message;
  }
}

export { importedProjectModel, importDataModel };
